import React, { useState } from "react";

import "./sla-counts.scss";

const keyToTextMap = {
    annualProductsCount: {
        text: "Annual Total Count",
        limitKey: "annualLimit",
        children: {
            physicalAnnualProductsCount: { text: "Annual Physical Count", limitKey: "physicalAnnualLimit" },
            digitalAnnualProductsCount: { text: "Annual Digital Count", limitKey: "digitalAnnualLimit" },
        },
    },
    monthlyProductsCount: {
        text: "Monthly Total Count",
        limitKey: "monthlyLimit",
        children: {
            physicalMonthlyProductsCount: { text: "Monthly Physical Count", limitKey: "physicalMonthlyLimit" },
            digitalMonthlyProductsCount: { text: "Monthly Digital Count", limitKey: "digitalMonthlyLimit" },
        },
    },
    weeklyProductsCount: {
        text: "Weekly Total Count",
        limitKey: "weeklyLimit",
        children: {
            physicalWeeklyProductsCount: { text: "Weekly Physical Count", limitKey: "physicalWeeklyLimit" },
            digitalWeeklyProductsCount: { text: "Weekly Digital Count", limitKey: "digitalWeeklyLimit" },
        },
    },
};

const ParentCount = ({ countData, mapData, value, limit = 0 }) => {
    const [show, setShow] = useState(false);
    const counts = Object.keys(mapData.children).reduce((childArr, k) => {
        const childValue = countData[k];
        const childLimit = countData[mapData.children[k].limitKey] ? countData[mapData.children[k].limitKey].toLocaleString() : "-";
        childArr.push(
            <li key={k}>
                {mapData.children[k].text}: <b>{childValue}</b> / {childLimit}
            </li>
        );

        return childArr;
    }, []);

    const toggleDetail = () => {
        setShow(!show);
    };

    const parentLimit = limit !== null ? limit.toLocaleString() : "-";
    const toggleIcon = show ? "-" : "+";

    return (
        <div className="parent-count">
            <div
                className="sla-total"
                onClick={toggleDetail}
            >
                {toggleIcon} {mapData.text || "Unknown"}: <b>{value ?? "-"}</b> / {parentLimit}
            </div>
            {show && <ul className="child-counts">{counts}</ul>}
        </div>
    );
};

const SLACounts = (props) => {
    const counts = Object.keys(keyToTextMap).reduce((arr, k) => {
        arr.push(
            <ParentCount
                key={k}
                id={k}
                mapData={keyToTextMap[k]}
                countData={props.data}
                value={props.data[k]}
                limit={props.data[keyToTextMap[k].limitKey]}
            />
        );

        return arr;
    }, []);

    return <div className="sla-counts">{counts}</div>;
};

export default SLACounts;
